"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import Image from "next/image";
import { motion } from "framer-motion";
import type { ReactNode } from "react";
type TrustedSplitProps = {
  title: ReactNode;
  paragraphs: string[];
  image: string;
  imageAlt: string;
  imageClassName?: string;
  darkImage?: string;
  darkImageAlt?: string;
  darkImageClassName?: string;
};
export default function TrustedSplit(t0) {
  const $ = _c(45);
  const {
    title,
    paragraphs,
    image,
    imageAlt,
    imageClassName: t1,
    darkImage,
    darkImageAlt,
    darkImageClassName: t2
  } = t0;
  const imageClassName = t1 === undefined ? "" : t1;
  const darkImageClassName = t2 === undefined ? "" : t2;
  const desktopAnimations = useDesktopAnimations();
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute inset-0 bg-[url('/images/shape/dot_bg.png')] bg-left-top bg-repeat opacity-100 dark:opacity-40" aria-hidden={true} />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== desktopAnimations) {
    t4 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[1] = desktopAnimations;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== desktopAnimations) {
    t5 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[3] = desktopAnimations;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== desktopAnimations) {
    t6 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[5] = desktopAnimations;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      once: true,
      amount: 0.25
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      duration: 0.8,
      ease: [0.17, 0.85, 0.438, 0.99]
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== title) {
    t9 = <h2 className="mb-5 max-w-[545px] font-poppins text-2xl font-semibold leading-[1.3] text-[#050748] sm:text-3xl md:leading-[1.3] xl:text-4xl dark:text-white">{title}</h2>;
    $[9] = title;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== paragraphs) {
    t10 = paragraphs.map(_temp);
    $[11] = paragraphs;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t9) {
    t11 = <motion.div initial={t4} whileInView={t5} animate={t6} viewport={t7} transition={t8} className="pl-0 md:pl-3 lg:pl-[25px]">{t9}{t10}</motion.div>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== desktopAnimations) {
    t12 = desktopAnimations ? {
      opacity: 0,
      y: 30
    } : false;
    $[19] = desktopAnimations;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== desktopAnimations) {
    t13 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[21] = desktopAnimations;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== desktopAnimations) {
    t14 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[23] = desktopAnimations;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      once: true,
      amount: 0.25
    };
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      duration: 0.8,
      delay: 0.1,
      ease: [0.17, 0.85, 0.438, 0.99]
    };
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  const t17 = `h-auto w-full max-w-[570px] object-contain ${darkImage ? "dark:hidden" : ""} ${imageClassName}`;
  let t18;
  if ($[27] !== image || $[28] !== imageAlt || $[29] !== t17) {
    t18 = <Image src={image} alt={imageAlt} width={570} height={448} className={t17} loading="lazy" />;
    $[27] = image;
    $[28] = imageAlt;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== darkImage || $[32] !== darkImageAlt || $[33] !== darkImageClassName || $[34] !== imageAlt) {
    t19 = darkImage ? <Image src={darkImage} alt={darkImageAlt ?? imageAlt} width={570} height={448} className={`hidden h-auto w-full max-w-[570px] object-contain dark:block ${darkImageClassName}`} loading="lazy" /> : null;
    $[31] = darkImage;
    $[32] = darkImageAlt;
    $[33] = darkImageClassName;
    $[34] = imageAlt;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t12 || $[37] !== t13 || $[38] !== t14 || $[39] !== t18 || $[40] !== t19) {
    t20 = <motion.div initial={t12} whileInView={t13} animate={t14} viewport={t15} transition={t16} className="flex justify-center md:justify-end">{t18}{t19}</motion.div>;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
    $[39] = t18;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t11 || $[43] !== t20) {
    t21 = <section className="relative overflow-hidden bg-white py-12 transition-colors duration-300 sm:py-16 lg:py-20 xl:py-18 dark:bg-gray-950">{t3}<div className="relative z-10 mx-auto w-full max-w-[1200px] px-[15px]"><div className="grid items-center gap-8 md:grid-cols-2 md:gap-6 lg:gap-[30px]">{t11}{t20}</div></div></section>;
    $[42] = t11;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  return t21;
}
function _temp(text, index) {
  return <p key={text.slice(0, 40)} className={`max-w-[545px] font-sans text-[16px] font-normal leading-7 text-[#6a6a8e] md:text-[17px] dark:text-gray-400 ${index === 0 ? "mt-2.5" : "mt-[25px]"}`}>{text}</p>;
}